var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSettingsSection',{attrs:{"name":_vm.title}},[_c('div',{staticClass:"settings-hint settingsHint"},[_vm._t("settingsHint")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }